/**
 * Verifica si la aplicación está ejecutándose en entorno de producción
 * @returns true si está en producción, false en desarrollo o otros entornos
 */
export const isProduction = (): boolean => {
  const isProductionByNodeEnv = import.meta.env.VITE_NODE_ENV === 'production';
  
  const isCI = import.meta.env.MODE === 'ci' && 
               import.meta.env.DEV === false && 
               import.meta.env.PROD === true;
  
  return isProductionByNodeEnv || isCI;
};

/**
 * Verifica si la aplicación está ejecutándose en entorno de desarrollo
 * @returns true si está en desarrollo, false en producción u otros entornos
 */
export const isDevelopment = (): boolean => {
  return import.meta.env.VITE_NODE_ENV === 'development';
};

/**
 * Obtiene el entorno actual de la aplicación
 * @returns string con el valor del entorno actual
 */
export const getCurrentEnvironment = (): string => {
  return import.meta.env.VITE_NODE_ENV || 'development';
};
